import { createContext, useContext } from 'react';

import { Session } from 'types/event.types';
import { Guest, GuestStatus } from 'types/guest.types';
import { QuestionResponse } from 'types/question-response.types';
import {
  EventForRSVPControl,
  GuestForRSVPControl,
  SessionAndStatus,
  WaitlistAdjustmentOption
} from 'types/rsvp_control.types';

export interface RSVPControlModalNavContextType {
  currentStepNumber: number;
  totalStepNumber: number;
  loading: boolean;
  onCancel: () => void;
  onClickBack: () => void;
  onClickSubmit: () => void;
}

export interface RSVPControlModalContextType {
  // navigation
  navigation: RSVPControlModalNavContextType;

  guest: GuestForRSVPControl;
  eventOrSessionId: number;
  event: EventForRSVPControl;

  // status
  selectedStatus?: GuestStatus;
  setSelectedStatus: (status: GuestStatus) => void;

  // waitlist adjustment
  requiresWaitlistAdjustment: boolean;
  waitlistAdjustmentOption?: WaitlistAdjustmentOption;
  setWaitlistAdjustmentOption: (option: WaitlistAdjustmentOption) => void;
  swapGuest?: Guest;
  setSwapGuest: (guest: Guest) => void;
  swapGuestStatus: GuestStatus;
  setSwapGuestStatus: (status: GuestStatus) => void;

  // swap session
  requiresSessionSwapConfirmation: boolean;
  currentSession?: Session;
  conflictingSessionAndStatus?: SessionAndStatus;

  // questionnaire
  requiresQuestionnaireSubmission: boolean;
  updatedResponses: QuestionResponse[];
  setUpdatedResponses: (updatedResponses: QuestionResponse[]) => void;

  // notifications
  sendNotifications: boolean;
  setSendNotifications: (value: boolean) => void;

  // plus ones
  shouldUpdateAllPlusOnesRsvp: boolean;
  setShouldUpdateAllPlusOnesRsvp: (value: boolean) => void;
}

export const RSVPControlModalContext = createContext<RSVPControlModalContextType | undefined>(
  undefined
);

export const useRSVPControlModalContext = (): RSVPControlModalContextType => {
  const context = useContext(RSVPControlModalContext);
  if (!context) throw new Error('useRSVPControlModalContext can only be used inside a provider');
  return context;
};
